var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgReshape = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.5549175 16.285311s.2579662 5.817418 1.5700825 9.902189c.7289974 2.269454 1.7218891 2.670911 2.2500001 2.75.8093592.121209 1.9261262.224112 2.625-.8125.6882033-1.020785 1.2938695-5.965254 1.7265625-6.835937.3441574-.692529 2.2286404-1.661248 3.4119364-1.757258 2.051454-.16645 3.705803.950737 3.773763.814816l.650238-4.971621z",
    fill: "#d5bc4c",
    stroke: "#555753"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.0273438 1.5019531c-2.8183472.0466368-5.2870436 1.2538894-6.2832032 4.1933594-.98846783 2.916771 1.1705509 8.1833015 5.9316406 5.8417965 7.9077408-3.8890266 7.9039248.962891 9.8808598.962891 2.438571 0 4.941406-1.699014 4.941406-3.8730469 0-1.944514.0964-3.8062211-.992188-4.8769531-1.976935-1.944514-2.973668.9860071-8.289062-1.1855469-1.694017-.6920746-3.4984442-1.090483-5.1894532-1.0625z",
    fill: "#8cbe8c",
    fillRule: "evenodd",
    stroke: "#555753",
    transform: "translate(0 8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.7054969 16.762163c-.043931.248944.7491571 1.933972 1.3700194 2.375437 1.3278104.944141 1.9284793 1.04651 2.4487555.985216 1.7389135-.204863 4.5632372-1.879107 5.9441162-1.933495.748164-.02947 1.441979-.131567 1.988738-.110483.503517.01942 1.856155.729204 1.966641.905981.110485.176776 1.281631 1.06066 1.281631 1.06066",
    fill: "none",
    stroke: "#8cbe8c",
    strokeDasharray: "1.2 2.4",
    strokeWidth: 1.2
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgReshape, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/reshape.f915a8bf.svg";
export { ForwardRef as ReactComponent };